import "./AboutUs.module.css";
import VoltMainHeader from "@/reusable_sections/Header";
import ATrustedInstitution from "./sections/ATrustedInstitution";
import PourquoiBoxify from "./sections/PourquoiBoxify";
import NosPiliers from "./sections/NosPiliers";
import ComprehensiveFooter from "@/reusable_sections/Footer";
export default function AboutUsPage() {
  return <div>
      <VoltMainHeader />
      <ATrustedInstitution />
      <PourquoiBoxify />
      <NosPiliers />
      <ComprehensiveFooter />
    </div>;
}